import { Component, Input, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges } from '@angular/core';

@Component({
	selector: 'switch-to-jack-lookup',
	templateUrl: './switch-to-jack-lookup.component.html',
	styleUrls: ['./switch-to-jack-lookup.component.scss']
})
export class SwitchToJackLookupComponent {

	constructor() {

	}

}